__turbopack_context__.v({
  "closeIcon": "MegaMenu-module-scss-module__kXIbfW__closeIcon",
  "hamburgerIcon": "MegaMenu-module-scss-module__kXIbfW__hamburgerIcon",
  "headerShadow": "MegaMenu-module-scss-module__kXIbfW__headerShadow",
  "level1Animation": "MegaMenu-module-scss-module__kXIbfW__level1Animation",
});
